import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};
@Injectable()
export class ProcessFndService {
  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public save(process: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ProcessFndService.ENV.environment.API.process_fnd, process,  httpRequesthandler);
  }

  public update(process: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(ProcessFndService.ENV.environment.API.process_fnd, process,  httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/process-fnd/process-fnd.service.ts